export default __webpack_public_path__ + "static/media/mustard-yellow-designify.e6dc0df4.png";